const ORDER_STATUS_OPTIONS = [
  { value: 'estimating', label: '見積中' },
  { value: 'ordered', label: '受注済' },
  { value: 'delivered', label: '納品済' },
  { value: 'invoiced', label: '請求済' },
  { value: 'paid', label: '入金済' },
  { value: 'canceled', label: 'キャンセル' },
];

export default ORDER_STATUS_OPTIONS;
